import { RootAction } from "../types";
import { SET_MESSAGE_SCROLLTOP } from "./actions";

export interface State {
  scrollTop: number;
}

export const blankState = (): State => ({
  scrollTop: 0
});

export default function reducer(state: State | undefined, action: RootAction): State {
  if (!state) {
    return reducer(blankState(), action);
  }

  switch (action.type) {
    case SET_MESSAGE_SCROLLTOP:
      return {
        ...state,
        scrollTop: action.scrollTop
      };

    default:
      return state;
  }
}
